"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.cashBalancePointerConfig = exports.cashBalanceFeedPointerMethod = exports.mapParafinBalanceReportCsvToCashBalancesCsv = void 0;
const assert_1 = __importDefault(require("assert"));
const lodash_1 = __importDefault(require("lodash"));
const finley_types_1 = require("@finley-technologies/finley-types");
const mapCsvToBorrowerCashBalancesFeed_1 = require("../mapCsvToBorrowerCashBalancesFeed");
// Map from Ramp-uploaded cash balances CSV to standard borrower cash balances CSV
const mapParafinBalanceReportCsvToCashBalancesCsv = (csvArray, reportingDate, creditFacilityId) => {
    // https://finleytechnologies.slack.com/archives/C02PVLGH31C/p1639500370037500
    const parafinCashBalances = csvArray.find((csvRow) => csvRow.balance_type === 'closing_available');
    (0, assert_1.default)(parafinCashBalances && lodash_1.default.isNumber(Number(parafinCashBalances.amount)), `Expected to find Parafin cash balances property from 'closing_available'`);
    const balance = (Number(parafinCashBalances.amount) / 100).toString();
    return [
        {
            facility_id: creditFacilityId,
            reportingDate,
            balance_type: finley_types_1.Bank.BorrowerAccountType.Collections,
            balance,
            refresh_date: reportingDate,
        },
    ];
};
exports.mapParafinBalanceReportCsvToCashBalancesCsv = mapParafinBalanceReportCsvToCashBalancesCsv;
const cashBalanceFeedPointerMethod = ({ borrowerId, csvArray, reportingDate, fileVersion, creditFacilityId, }) => {
    const mappedCsvArray = (0, exports.mapParafinBalanceReportCsvToCashBalancesCsv)(csvArray, reportingDate, creditFacilityId);
    return (0, mapCsvToBorrowerCashBalancesFeed_1.mapCsvToBorrowerCashBalancesFeed)({
        borrowerId,
        csvArray: mappedCsvArray,
        reportingDate,
        fileVersion,
        creditFacilityId,
    });
};
exports.cashBalanceFeedPointerMethod = cashBalanceFeedPointerMethod;
exports.cashBalancePointerConfig = {
    pointer: 'parafinAtalaya1',
    method: exports.cashBalanceFeedPointerMethod,
};
//# sourceMappingURL=cashBalanceFeedPointerMethod.js.map